module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n            Administration\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MAIN NAVIGATION")]), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/servers-data"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', [_vm._v("Informations")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/sql"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', [_vm._v("SQL Execute")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 20) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/chats/history"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('span', [_vm._v("Chat History")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin-chat"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('span', [_vm._v("Admin Chat")])])], 1), _vm._v(" "), _c('li', [(_vm.fullAdmin >= 20) ? _c('router-link', {
    attrs: {
      "to": "/chats"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('span', [_vm._v("Chats")])]) : _vm._e()], 1), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Users")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/ban"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('span', [_vm._v("Ban")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/facebook-switch"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Facebook merge")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/coins"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Coins")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/skins"
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" "), _c('span', [_vm._v("Skins")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/private-skins"
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" "), _c('span', [_vm._v("Private skins")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/skins-managment"
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" "), _c('span', [_vm._v("New skins "), _c('span', {
    staticClass: "label label-info"
  }, [_vm._v(_vm._s(_vm.waitSkins))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/private-skins-managment"
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" "), _c('span', [_vm._v("New private skins "), _c('span', {
    staticClass: "label label-info"
  }, [_vm._v(_vm._s(_vm.waitPrivateSkins))])])])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-aqua"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.number_of_skins))]), _vm._v(" "), _c('p', [_vm._v("Skinova")])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-red"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.number_of_private_skins))]), _vm._v(" "), _c('p', [_vm._v("Privatnih skinova")])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-red"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.number_of_users))]), _vm._v(" "), _c('p', [_vm._v("Registrovanih igrača")])]), _vm._v(" "), _vm._m(4)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/analytic"
    }
  }, [_c('i', {
    staticClass: "fa fa-google"
  }), _vm._v(" "), _c('span', [_vm._v("Analytic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/block-analytics"
    }
  }, [_c('i', {
    staticClass: "fa fa-google"
  }), _vm._v(" "), _c('span', [_vm._v("Block Analytics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-photo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-photo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-pie-graph"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5671db48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/dashboard.vue
// module id = 309
// module chunks = 2